import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ActivityHistoryCard } from '@europrocurement/flexy-components';
import { useTheme } from '@mui/material';
import { forbiddenIcon, preview } from '@europrocurement/l2d-icons';
import ActivitiesCardContent from '../ActivitiesCardContent/ActivitiesCardContent';
import useActivitiesHook from '../../../hooks/useActivitiesHook';

interface DossierHistoryTabProps {
    showTechniqueLogs?: boolean;
    showLogData?: boolean;
    requestLogActionLimited?: boolean;
}

const DossierHistoryTab: React.FunctionComponent<DossierHistoryTabProps> = function ({
    showTechniqueLogs = false,
    showLogData = true,
    requestLogActionLimited = true,
}) {
    const { palette } = useTheme();
    const [showLogsTechniques, setShowLogsTechniques] = useState(false);

    const { activities, activitiesLoading, loadActivitiesTechniques } = useActivitiesHook({
        useMemoClient: false,
        requestLogActionLimited,
        loadLogs: true,
    });

    const handleLoadTechniques = useCallback(() => {
        setShowLogsTechniques((prev) => !prev);
    }, []);

    useEffect(() => {
        loadActivitiesTechniques(showLogsTechniques);
    }, [showLogsTechniques, loadActivitiesTechniques]);

    const textLogsTechnique = showLogsTechniques
        ? 'Masquer les actions techniques'
        : 'Afficher les actions techniques';

    const showIconTechniques = showLogsTechniques ? forbiddenIcon : preview;

    const actionActivities = useMemo(
        () => activities.filter((a) => a.type === 'action'),
        [activities],
    );

    const actions = useMemo(
        () =>
            showTechniqueLogs
                ? [
                      {
                          id: 'show-technique',
                          label: textLogsTechnique,
                          shortLabel: 'Afficher',
                          icon: showIconTechniques,
                          onClick: handleLoadTechniques,
                          variant: 'text' as const,
                          color: palette.grey[700],
                      },
                  ]
                : [],
        [
            showTechniqueLogs,
            textLogsTechnique,
            showIconTechniques,
            handleLoadTechniques,
            palette.grey,
        ],
    );

    return (
        <ActivityHistoryCard actions={actions}>
            <ActivitiesCardContent
                activities={actionActivities}
                activitiesLoading={activitiesLoading}
                showLogData={showLogData}
                title="Historique"
            />
        </ActivityHistoryCard>
    );
};

export default DossierHistoryTab;
